module.exports = __webpack_public_path__ + "img/home-icon-dark.6064f65c.svg";